// A presentation-only invitation gate, NOT authentication or access control.
// This value ships to the browser. Never use a real account password here.
export const entryConfig = {
  passcode: "P20261001000000",
  title: ["今夜，", "星光为你而来。"],
  line: "有一份惊喜，藏在这片夜色里。",
  action: "开启这一夜",
} as const;

export function matchesInvitationPasscode(value: string): boolean {
  return value.trim() === entryConfig.passcode;
}
